import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap";
import ChartAccessesPerMonth from '../_Base/AccessesPerMonth'
import PropTypes from 'prop-types';

const AccessPerMonth = (props) => {
    const { t } = useTranslation();
    const inputParam_ChartData = props.chartData !== undefined && props.chartData !== null ? props.chartData : null;

    return (  
        <Card className='access-per-month-form'>
            <Card.Header>
                <Card.Title className="d-flex justify-content-between">
                    <h4><b>{t('data-lang-boxname-chart-accesspermonth')}</b></h4>
                </Card.Title>
            </Card.Header>
            <Card.Body style={{width: "100%"}} className="access-per-month-form-body">
                <Row style={{height: "100%"}} className="align-items-center">
                    <ChartAccessesPerMonth chartData={inputParam_ChartData} />
                </Row>
            </Card.Body>
            <Card.Footer>
            </Card.Footer>
        </Card>
    );
};
AccessPerMonth.propTypes = {
    chartData: PropTypes.object.isRequired,
};
export default AccessPerMonth;